var map = {
	"./s-1/song.mp3": [
		12333,
		6272
	],
	"./s-10/song.mp3": [
		12334,
		6273
	],
	"./s-11/song.mp3": [
		12335,
		6274
	],
	"./s-12/song.mp3": [
		12336,
		6275
	],
	"./s-13/song.mp3": [
		12337,
		6276
	],
	"./s-14/song.mp3": [
		12338,
		6277
	],
	"./s-15/song.mp3": [
		12339,
		6278
	],
	"./s-16/song.mp3": [
		12340,
		6279
	],
	"./s-17/song.mp3": [
		12341,
		6280
	],
	"./s-18/song.mp3": [
		12342,
		6281
	],
	"./s-19/song.mp3": [
		12343,
		6282
	],
	"./s-2/song.mp3": [
		12344,
		6283
	],
	"./s-20/song.mp3": [
		12345,
		6284
	],
	"./s-3/song.mp3": [
		12346,
		6285
	],
	"./s-4/song.mp3": [
		12347,
		6286
	],
	"./s-5/song.mp3": [
		12348,
		6287
	],
	"./s-6/song.mp3": [
		12349,
		6288
	],
	"./s-7/song.mp3": [
		12350,
		6289
	],
	"./s-8/song.mp3": [
		12351,
		6290
	],
	"./s-9/song.mp3": [
		12352,
		6291
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1660;
module.exports = webpackAsyncContext;